// extracted by mini-css-extract-plugin
export default {"Switch":"InputToogle_Switch__ydnrr","Slider":"InputToogle_Slider__+NDgG","Round":"InputToogle_Round__ur4m1"};